// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2D7ut","title":"card_title__2G2Wp","inActive":"card_inActive__8k-sQ"};